export default {"src":"/frontend-static/_next/static/media/sofortLight.27193e82.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};